import type { FormFieldSize } from '../../helpers/field-size';

/**
 * Cascader オプション型
 */
export type CascaderOption = {
  label: string;
  value: string;
  children?: CascaderOption[];
  disabled?: boolean;
  /** 無効化の理由（ツールチップで表示） */
  disabledReason?: string;
};

/**
 * チェック済み表示戦略
 */
export enum ShowCheckedStrategy {
  /** 親ノードを表示 */
  SHOW_PARENT = 'SHOW_PARENT',
  /** 子ノード（リーフ）のみ表示 */
  SHOW_CHILD = 'SHOW_CHILD',
}

/**
 * Cascader プロパティ型
 */
export type CascaderProps = {
  /** 要素のID（FormFieldWrapper との連携用） */
  id?: string;
  /** オプションのツリー構造 */
  options: CascaderOption[];
  /** 選択された値のパス（単一選択: string[], 複数選択: string[][]） */
  value?: string[] | string[][];
  /** 値変更時のコールバック */
  onChange?: (
    value: string[] | string[][],
    selectedOptions: CascaderOption[] | CascaderOption[][],
  ) => void;
  /** プレースホルダー */
  placeholder?: string;
  /** 無効状態 */
  disabled?: boolean;
  /** エラー状態 */
  hasError?: boolean;
  /** カスタムクラス名 */
  className?: string;
  /** 検索を有効にする（単一選択のみ） */
  showSearch?: boolean;
  /** 変更をトリガーするタイミング */
  changeOnSelect?: boolean;
  /** カスタム表示レンダラー（単一選択のみ） */
  displayRender?: (labels: string[]) => string;
  /** 複数選択を有効にする */
  multiple?: boolean;
  /** チェック済みアイテムの表示戦略（複数選択時のみ） */
  showCheckedStrategy?: ShowCheckedStrategy;
  /** 表示するタグの最大数（複数選択時のみ） */
  maxTagCount?: number | 'responsive';
  /** フィールドの最小幅（デフォルト: md） */
  size?: FormFieldSize;
  /** 無効化するアイテムの値配列 */
  disabledItemValues?: string[];
  /** 無効化アイテムの理由マップ（値 → 理由テキスト） */
  disabledItemReasons?: Record<string, string>;
  /** クリアボタンを表示するか（値が入力されている場合のみ表示） */
  showAllClear?: boolean;
  /** 末端ノード（リーフ）のみ選択可能にする（中間階層での選択を禁止） */
  onlyLeafSelectable?: boolean;
};
